var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fm-internal"},[_c('div',{staticStyle:{"max-width":"800px","min-width":"300px"}},[_c('b-card',{attrs:{"no-body":""}},[_c('qrcode-stream',{on:{"decode":_vm.on_decode,"init":_vm.on_init}})],1)],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d408d44","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Scanner.vue
// module id = null
// module chunks = 